import { GET_WRITING_SURFACE_TYPES_LOADING, GET_WRITING_SURFACE_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getWritingSurfaceTypesSuccess = payload => {
    return ({
        type: GET_WRITING_SURFACE_TYPES_SUCCESS,
        payload
    })
}

export const getWritingSurfaceTypesAsync = payload => dispatch => {
    return client.service('writing-surface-types').find()
		.then((response) => {
            dispatch(getWritingSurfaceTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}